import { useEffect, useRef, useState } from 'react';

import { Form } from 'react-bootstrap';
import { Eye, EyeSlash } from 'react-bootstrap-icons';
import { useFormContext } from 'react-hook-form';

import { getComponentFormError } from '../../../utils';

import './style.scss';

interface Props {
  label: string;
  name: string;
  autoFocus?: boolean;
  defaultValue?: string;
}

function Password(props: Props) {
  const inputRef = useRef<HTMLInputElement | null>(null);
  const [showPassword, setShowPassword] = useState(false);
  const methods = useFormContext();
  const { label, name, autoFocus, defaultValue } = props;
  const {
    register,
    formState: { errors }
  } = methods;

  const error = getComponentFormError(name, errors);
  const { ref: registerRef, ...passwordField } = register(name);

  useEffect(() => {
    if (autoFocus) {
      inputRef.current?.focus();
    }
  }, [autoFocus]);

  return (
    <Form.Group>
      <Form.Label>{label}</Form.Label>
      <div className="dec-password-field">
        <Form.Control
          autoFocus={autoFocus}
          className="dec-password-field__input"
          defaultValue={defaultValue}
          type={showPassword ? 'text' : 'password'}
          {...passwordField}
          ref={(element: HTMLInputElement | null) => {
            registerRef(element);
            inputRef.current = element;
          }}
          isInvalid={error ? true : false}
        />
        <button
          aria-label={showPassword ? 'Hide password' : 'Show password'}
          className="dec-password-field__toggle"
          onClick={() => setShowPassword((value) => !value)}
          type="button">
          {showPassword ? <EyeSlash /> : <Eye />}
        </button>
      </div>
      <Form.Control.Feedback className={error ? 'd-block' : undefined} type="invalid">
        {error ? error.message : ''}
      </Form.Control.Feedback>
    </Form.Group>
  );
}

export default Password;
